<template>
  <div class="info-modal__content__title">
    <h4>{{ $t('modal_content.purchase_price.title') }}</h4>
  </div>
  <div class="info-modal__content__text">
    <div v-html="$t('modal_content.purchase_price.text')" />
    <div v-html="$t('modal_content.purchase_price.more_questions')" />
    <div v-html="$t('modal_content.purchase_price.contact.text')" />
    <div class="info-modal__content__contact">
      <div class="info-modal__content__contact__contact-item">
        <LIcon icon="lnx-phone" color="primary" :size="24" />
        <div v-html="$t('modal_content.purchase_price.contact.phone')" />
      </div>
      <div class="info-modal__content__contact__contact-item">
        <LIcon icon="lnx-mail" color="primary" :size="24" />
        <div v-html="$t('modal_content.purchase_price.contact.email')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LIcon } from '@wgg.hyve/hyve-ui-library'
</script>
